export default __webpack_public_path__ + "static/media/23.4dfc7739.png";